// extracted by mini-css-extract-plugin
module.exports =  {"container":"_93444fe79c--container--Eyeh9","label":"_93444fe79c--label--nZqvB"};